/*
 * Entry point for the Softaware Greek Editor Word Add-in (React).
 *
 * Mounts the React tree once Office.js is ready and confirms the host is Word.
 * The cold-start session probe lives in App's useBootstrap effect.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { FluentProvider, webLightTheme, type Theme } from "@fluentui/react-components";
import { App } from "./App";

const softawareTheme: Theme = {
  ...webLightTheme,
  colorBrandBackground: "#00282c",
  colorBrandBackgroundHover: "#001a1e",
  colorBrandBackgroundPressed: "#001a1e",
  colorBrandBackgroundSelected: "#00282c",
  colorBrandForeground1: "#00282c",
  colorBrandForeground2: "#0f766e",
  colorBrandStroke1: "#00282c",
  colorBrandStroke2: "#0f766e",
  colorCompoundBrandForeground1: "#00282c",
  colorCompoundBrandStroke: "#00282c",
};

Office.onReady((info) => {
  if (info.host !== Office.HostType.Word) return;

  const container = document.getElementById("root");
  if (!container) return;

  createRoot(container).render(
    <StrictMode>
      <FluentProvider theme={softawareTheme}>
        <App />
      </FluentProvider>
    </StrictMode>
  );

  // The static pre-mount overlay (in taskpane.html) is now replaced by the
  // React-controlled LoadingOverlay.
  document.getElementById("static-loading-overlay")?.remove();
});
